import { Typography } from "antd";

const AppHeader = () => {
  return (
    <div
      style={{
        textAlign: "center",
      }}
    >
      <Typography.Title level={3}>MEDIEASY</Typography.Title>
    </div>
  );
};

export default AppHeader;
